import { useSecure } from 'libs/additiv-react-oidc-client';
import { useCallback } from 'react';
import { INIT_LOCATION } from '../../../constants/sessionStorageKeys';

export const useAuth = () => {
    const { logout: signOut } = useSecure();

    const logout = useCallback(() => {
        sessionStorage.removeItem(INIT_LOCATION);
        sessionStorage.removeItem('systemMessageClosed');
        sessionStorage.removeItem('activeSystemMessage');
        signOut();
    }, [signOut]);

    return { logout };
};
